module.exports = __webpack_public_path__ + "static/media/HorizontalBasic300.1e3e1292.svg";